import { moduleName as recordModuleName } from "../../records/index";
import { configureLookupManagement } from "../../records/lookup/lookupManagement/config";

import angular from "angular";
import {
  vsLookupManagementServiceName,
  vsLookupManagementServiceProviderName,
} from "./lookups";
import { mealLogReasonConfig } from "./reasons";
import { mealLogConfig } from "./mealLog";

export const vsModuleName = "SlotTrak.Machines.MealLog.Config";

const module = angular
  .module(vsModuleName, [recordModuleName])
  .config(mealLogReasonConfig)
  .config(mealLogConfig);

configureLookupManagement(module, {
  baseStateSref: "main.mealLog.lookups",
  lookupManagementServiceName: vsLookupManagementServiceName,
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
  entryView: "@^.^",
  defaultModifyPermission: "mealLogLookupModify",
});
